import { BANNER_CONSTANTS, BANNER_VARIANTS } from '@/constants/banners';

export interface MobileBannerConfig {
  variant?: 'prelaunch' | 'services' | 'training' | 'default';
  title: string;
  description: string;
  buttonText?: string;
  buttonAction?: () => void;
  leftPillText?: string;
  rightText?: string;
}

export const useMobileBanner = () => {
  const { t } = useI18n();
  const { isDesktop } = useAppBreakpoints();
  const { isRouteMatch, hasQueryParam } = useRouteHelpers();
  const training = useTraining();

  const openTelegramChannel = () => {
    window.open(BANNER_CONSTANTS.TELEGRAM.URL, '_blank');
  };

  const shouldShowPrelaunchBanner = (): boolean => {
    if (isDesktop.value) return false;
    return !hasQueryParam('explore', 'map');
  };

  const getBannerConfig = (): MobileBannerConfig | null => {
    if (isRouteMatch(['index', 'prelaunch']) && shouldShowPrelaunchBanner()) {
      return {
        variant: BANNER_VARIANTS.PRELAUNCH,
        title: t(BANNER_CONSTANTS.PRELAUNCH.TITLE),
        description: t(BANNER_CONSTANTS.PRELAUNCH.DESCRIPTION),
        buttonText: t(BANNER_CONSTANTS.TELEGRAM.TEXT),
        buttonAction: openTelegramChannel,
      };
    }

    if (isRouteMatch(['services'])) {
      return {
        variant: BANNER_VARIANTS.SERVICES,
        title: t(BANNER_CONSTANTS.SERVICES.TITLE),
        description: t(BANNER_CONSTANTS.SERVICES.DESCRIPTION),
        // Not common.actions.learnMore ("Learn more") — this button's original text was
        // capitalized "Learn More"; kept byte-identical via its own key.
        buttonText: t('shell.mobileBanner.learnMore'),
        buttonAction: () => navigateTo('/services'),
        leftPillText: BANNER_CONSTANTS.SERVICES.LEFT_PILL_DEFAULT,
        rightText: BANNER_CONSTANTS.SERVICES.RIGHT_TEXT_DEFAULT,
      };
    }

    if (isRouteMatch(['training'])) {
      return {
        variant: BANNER_VARIANTS.TRAINING,
        title: t('shell.mobileBanner.videosWatched', { count: training.watchedCount.value }),
        description: '',
      };
    }

    return null;
  };

  const getHeaderHeight = (): number => {
    const baseHeaderHeight = 88;
    const bannerConfig = getBannerConfig();

    if (bannerConfig) {
      return baseHeaderHeight + 60;
    }

    return baseHeaderHeight;
  };

  return {
    getBannerConfig,
    getHeaderHeight,
  };
};
